import React, { useMemo } from "react";
import { AppBar, Toolbar, Button, Box, Link, useMediaQuery } from "@mui/material";
import { minHeight, styled } from "@mui/system";
import { useLocation, Link as RouterLink } from "react-router-dom";
// import useAuth from "../hooks/useAuth"; // 假设你有一个自定义的 useAuth 钩子
import FocusGhostButton from "../../../components/NewButtons/FocusGhostButton";
import { useSelector } from "react-redux";
import { ReactComponent as SiteLogo } from "../../../assets/icons/siteLogo.svg";
import { config } from "../../../config";
import UserProfileMenu from "../../../components/NewButtons/UserProfileMenu";

const SiteHeaderPlaceholder = styled("div")(({ theme }) => ({
  // height: "var(--navbar-height)"
}));

const SiteHeader = styled("header")(({ theme }) => ({
  "--bg-color": "black",
  height: "var(--navbar-height)",
  borderBottom: "1px solid #323232",
  backgroundImage: "radial-gradient(transparent 1px, var(--bg-color) 1px)",
  backgroundSize: "4px 4px",
  backdropFilter: "saturate(50%) blur(10px)",
  position: "fixed",
  zIndex: 233,
  top: 0,
  width: "100%"
}));

const SiteHeaderComponent = ({ needPlaceholder = true }) => {
  // const { isAuthed, login } = useAuth();
  const auth = useSelector((state) => state.auth);
  const isAuthed = useMemo(() => {
    return !!auth?.user?.token;
  }, [auth]);
  const login = () => {
    window.location.href = config.SSO_CLIENT_URL;
  };
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      {needPlaceholder && <SiteHeaderPlaceholder />}
      <SiteHeader
        position="static"
        style={{
          height: isMobile ? "63px" : "88px"
        }}>
        <Toolbar
          className=""
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            height: "100%",
            margin: "auto",
            backgroundColor: "transparent"
          }}>
          {/* <Box className="left-part">
            <a href={`${config.DELYSIUM_ONE_CLIENT_URL}fund`}>
              <FocusGhostButton
                sx={{
                  width: isMobile ? "85px" : "100%",
                  minWidth: isMobile ? "85px" : "168px",
                  height: isMobile ? "32px" : "100%",
                  minHeight: isMobile ? "32px" : "50px",
                  fontSize: isMobile ? "13px" : "16px"
                }}>
                AI FUND
              </FocusGhostButton>
            </a>
          </Box> */}
          <Box
            className="center-part"
            sx={{
              overflow: "hidden"
            }}>
            <Box
              component={"a"}
              href={`${config.DELYSIUM_ONE_CLIENT_URL}`}
              sx={{
                "& svg": {
                  height: isMobile ? "35px" : "100%"
                },
                position: "relative",
                left: isMobile ? "-28px" : "0px"
              }}>
              <SiteLogo />
            </Box>
          </Box>
          <Box className="right-part">
            {!isAuthed ? (
              <FocusGhostButton
                onClick={login}
                sx={{
                  width: isMobile ? "85px" : "100%",
                  minWidth: isMobile ? "85px" : "168px",
                  height: isMobile ? "32px" : "100%",
                  minHeight: isMobile ? "32px" : "50px",
                  fontSize: isMobile ? "13px" : "16px"
                }}>
                LOGIN
              </FocusGhostButton>
            ) : (
              <UserProfileMenu />
            )}
          </Box>
        </Toolbar>
      </SiteHeader>
    </>
  );
};

export default SiteHeaderComponent;
